import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router'
import type { RouterContext } from '@/app/router-context'
import { StatePanel } from '@/components/common/state-panel'
import { AuthLayout } from '@/components/layout/auth-layout'
import { useI18n } from '@/i18n'
export const Route = createRootRouteWithContext<RouterContext>()({ component: Outlet, notFoundComponent: NotFound, errorComponent: ErrorPage })
function NotFound() {
  const { locale } = useI18n()
  return <AuthLayout><StatePanel kind='empty' title='404' description={locale === 'zh-CN' ? '页面不存在' : 'Page not found'}><Link to='/overview' className='text-sm underline'>{locale === 'zh-CN' ? '返回控制台' : 'Return to console'}</Link><Link to='/support' className='text-sm underline'>{locale === 'zh-CN' ? '联系支持' : 'Contact support'}</Link></StatePanel></AuthLayout>
}
function ErrorPage() {
  const { locale } = useI18n()
  return <AuthLayout><StatePanel kind='error' description={locale === 'zh-CN' ? '无法加载页面，请重新加载或联系支持。' : 'Unable to load this page. Reload or contact support.'}><Link to='/support' className='underline'>{locale === 'zh-CN' ? '联系支持' : 'Contact support'}</Link></StatePanel></AuthLayout>
}
